import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import SectionTitle from '../atoms/SectionTitle'
import { connect } from 'react-redux'
import ContainerWithImage from '../atoms/ContainerWithImage'
import doubleRoomImg from '../../images/room2_service.png'
import carParkImg from '../../images/car-park.png'
import wiFiImg from '../../images/wi-fi.png'
import kitchenImg from '../../images/gril.png'
import saunaImg from '../../images/sauna.png'
import showerImg from '../../images/shower.png'
import heatingImg from '../../images/ac_service1.png'
import handicappedImg from '../../images/handicapped_service.png'
import TVImg from '../../images/TV_service.png'

const HighStandardsSection= props => {
  const { translations, color, backgroundColor, borderColor } = props
  const classes = useStyles({color, backgroundColor, borderColor})
  return (
    <div>
      <SectionTitle title={translations.title} subtitle={translations.subtitle} color={props.color} backgroundColor={props.backgroundColor} paddingTop='70px'/>
        <div className={classes.standardSection}>
          <ContainerWithImage
            styles={{backgroundColor: props.backgroundColor, borderColor: props.borderColor}}
            img={doubleRoomImg}
            title={translations.double_rooms}
            description={translations.double_rooms_desription}
          />
          <ContainerWithImage
            styles={{backgroundColor: props.backgroundColor, borderColor: props.borderColor}}
            img={showerImg}
            title={translations.shower}
            description={translations.shower_description}
          />
          <ContainerWithImage
            styles={{backgroundColor: props.backgroundColor, borderColor: props.borderColor}}
            img={saunaImg}
            title={translations.sauna}
            description={translations.sauna_description}
          />
          <ContainerWithImage
            styles={{backgroundColor: props.backgroundColor, borderColor: props.borderColor}}
            img={heatingImg}
            title={translations.heating}
            description={translations.heating_description}
          />
          <ContainerWithImage
            styles={{backgroundColor: props.backgroundColor, borderColor: props.borderColor}}
            img={kitchenImg}
            title={translations.kitchen}
            description={translations.kitchen_description}
          />
          <ContainerWithImage
            styles={{backgroundColor: props.backgroundColor, borderColor: props.borderColor}}
            img={wiFiImg}
            title={translations.wifi}
            description={translations.wifi_description}
          />
          <ContainerWithImage
            styles={{backgroundColor: props.backgroundColor, borderColor: props.borderColor}}
            img={TVImg}
            title={translations.tv}
            description={translations.tv_description}
          />
          <ContainerWithImage
            styles={{backgroundColor: props.backgroundColor, borderColor: props.borderColor}}
            img={handicappedImg}
            title={translations.handicapped}
            description={translations.handicapped_description}
          />
          <ContainerWithImage
            styles={{backgroundColor: props.backgroundColor, borderColor: props.borderColor}}
            img={carParkImg}
            title={translations.car_park}
            description={translations.car_park_description}
          />
        </div>
    </div>
  )
}

HighStandardsSection.propTypes = {
  translations: PropTypes.object.isRequired,
}

const useStyles = createUseStyles({

  standardSection: {
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: '3em',
      justifyContent: 'space-between',
      marginLeft: '10px',
  },
  '@media(max-width: 960px)': {
    standardSection: {
      marginLeft: '-10px',
    },
  },
  '@media(max-width: 480px)': {
    standardSection: {
      marginLeft: '-10px',
    },
  },
  '@media(min-width: 1400px)': {
    standardSection: {
     minWidth: '1400px',
     marginLeft: '-10px',
    },
  },
})

const mapStateToProps = state => {
  return {
    translations: state.translations.translations.high_standards_section,
  }
}

export default connect(mapStateToProps)(HighStandardsSection)
